// Orchestrator module that exports all search functionality

// Import all functions
import { hasFulltextResults } from './app-initialization.search/has-results.js';
import { initializeSearchInput, handleSearchInput, handleSearchSubmit, debounceSearch, executeSearch } from './app-initialization.search/search-input.js';
import { performFulltextSearch } from './app-initialization.search/search-api.js';
import { renderFulltextResults } from './app-initialization.search/render-results.js';
import { updateFulltextRequestMismatchIndicator } from './app-initialization.search/request-indicator.js';

// Export all modules for backward compatibility
export { hasFulltextResults };
export { initializeSearchInput, handleSearchInput, handleSearchSubmit, debounceSearch, executeSearch };
export { performFulltextSearch };
export { renderFulltextResults };
export { updateFulltextRequestMismatchIndicator };

// Global exports for backward compatibility and browser history handler
if (typeof window !== 'undefined') {
    window.performFulltextSearch = performFulltextSearch;
    window.renderFulltextResults = renderFulltextResults;
    window.hasFulltextResults = hasFulltextResults;
}
